import React from "react";
import { v4 as uuid } from "uuid";
import _ from "lodash";

import { instantSave } from "../../helpers.js";
// import styles from "./styles.scss"
import FeatureItem from "./FeatureItem";
import styles from "./styles.scss";

// remove blank or incomplete feature items
const filterItems = (items) =>
  items
    .filter((i) => i.context && i.date)
    .map(({ context, date, dateTo, custom }) =>
      context && date ? { context, date, dateTo, custom } : null
    )
    .filter((i) => !!i);

const featureOptions = {
  project: [
    { value: "library", label: "library" },
    { value: "library preview", label: "library preview" },
    {
      value: "library homepage selections",
      label: "library homepage selections",
    },
    {
      value: "library homepage from this month",
      label: "library homepage from this month",
    },
    { value: "library homepage random", label: "library homepage random" },
    { value: "daily", label: "daily", custom: "Selected by" },
  ],
  artist: [
    { value: "library", label: "library" },
    { value: "quarterly", label: "quarterly" },
  ],
  space: [{ value: "daily ad", label: "daily ad" }],
  venue: [{ value: "library", label: "library" }],
  page: [
    { value: "library", label: "library" },
    { value: "daily", label: "daily" },
    { value: "daily navigation", label: "daily navigation" },
    { value: "daily announcement", label: "daily announcement", to: true },
    { value: "library navigation", label: "library navigation" },
    { value: "library announcement", label: "library announcement" },
    { value: "edu navigation", label: "edu navigation" },
  ],
};

export default class extends React.Component {
  state = {
    items: [],
    options: [],
    loaded: false,
  };

  handleAddItem = (e) => {
    e.preventDefault();

    this.setState({
      items: this.state.items.concat({ uuid: uuid(), date: new Date() }),
    });
  };

  handleChange = (item) => {
    const items = _.uniqBy(
      this.state.items.map((i) => {
        if (i.uuid !== item.uuid) return i;
        return item;
      }),
      "context"
    );

    this.setState({ items });
  };

  componentDidUpdate(prevProps, prevState) {
    let { items } = this.state;

    // if adding a daily feature, set the time to now + 2 hours
    if (
      !prevState.items.filter((item) => item.context === "daily").length &&
      items.filter((item) => item.context === "daily").length &&
      prevState.loaded // only do this after props are loaded
    ) {
      const twoHoursFromNow = new Date();
      twoHoursFromNow.setHours(twoHoursFromNow.getHours() + 2);

      items = [
        ...items.filter((item) => item.context !== "daily"),
        {
          uuid: uuid(),
          date: twoHoursFromNow,
          context: "daily",
        },
      ];

      this.setState({ items });
    }

    // if adding a Daily or Library announcement, load a modal
    // explaining how to upload an image
    if (
      !prevState.items.filter(
        (item) =>
          item.context === "daily announcement" ||
          item.context === "library announcement"
      ).length &&
      items.filter(
        (item) =>
          item.context === "daily announcement" ||
          item.context === "library announcement"
      ).length &&
      prevState.loaded // only do this after props are loaded
    ) {
      alert("Refresh this page to upload an image to the announcement.");
    }

    if (
      JSON.stringify(filterItems(prevState.items)) !==
      JSON.stringify(filterItems(items))
    ) {
      instantSave();
    }
  }

  componentDidMount() {
    const itemProp = this.props.items ? JSON.parse(this.props.items) : [];
    const items = itemProp.map(({ context, date, dateTo, custom }) => ({
      context,
      date: new Date(date),
      dateTo: dateTo ? new Date(dateTo) : null,
      custom,
      uuid: uuid(),
    }));

    const moreOptions = featureOptions[this.props.recordType] || [];
    let options = moreOptions;

    options = _.sortBy(options, (x) => x.value);

    this.setState({
      items,
      options,
      loaded: true,
    });
  }

  render() {
    const { items, options } = this.state;

    return (
      <div className={styles.wrap}>
        <div className={styles.items}>
          {items.map((item, i) => (
            <FeatureItem
              options={options}
              key={item.uuid}
              item={item}
              onChange={this.handleChange}
            />
          ))}
        </div>
        <div className={styles.buttonWrap} onClick={this.handleAddItem} />
        <input
          type="hidden"
          name={`${this.props.recordType}[feature_list]`}
          value={JSON.stringify(filterItems(items))}
        />
      </div>
    );
  }
}
